import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> {}

const UnderstandIcon: React.FC<SVGProps> = (props) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = props?.fill?.trim() ? props?.fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";

  return (
    <svg
      width={341}
      height={356}
      viewBox="0 0 341 356"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: finalColor }}
      {...props}
    >
      <path
        d="M141.74 355.3C138.78 355.3 135.82 354.54 133.18 353.01L24.5002 290.03C9.39023 281.31 -0.00976562 265.03 -0.00976562 247.56V107.75C-0.00976562 90.28 9.39023 74.01 24.5102 65.27L133.17 2.55002C138.44 -0.48998 144.98 -0.48998 150.24 2.55002C155.5 5.59002 158.77 11.25 158.77 17.33L158.8 338.24C158.8 344.32 155.53 349.99 150.25 353.03C147.62 354.54 144.67 355.3 141.73 355.3H141.74ZM134.78 29.33L36.5302 86.06C28.8102 90.52 24.0102 98.83 24.0102 107.75V247.56C24.0102 256.48 28.8102 264.79 36.5302 269.25L134.81 326.21L134.78 29.34V29.33Z"
        fill="currentColor"
      />
      <path
        d="M197.88 355.32C194.93 355.32 191.97 354.56 189.34 353.04C184.08 350 180.81 344.33 180.82 338.26L181 17.05C181 10.97 184.27 5.31 189.54 2.28C194.8 -0.76 201.34 -0.76 206.6 2.28L315.73 65.29C330.86 74.02 340.25 90.3 340.25 107.76V247.57C340.25 265.04 330.85 281.31 315.73 290.04L206.41 353.05C203.78 354.57 200.83 355.32 197.89 355.32H197.88ZM204.99 29.06L204.82 326.26L303.73 269.25C311.45 264.79 316.25 256.48 316.25 247.56V107.75C316.25 98.83 311.45 90.52 303.73 86.06L204.99 29.05V29.06Z"
        fill="currentColor"
      />
      <path
        d="M107.25 123.99C119.367 123.99 129.19 114.167 129.19 102.05C129.19 89.9327 119.367 80.1099 107.25 80.1099C95.1329 80.1099 85.3101 89.9327 85.3101 102.05C85.3101 114.167 95.1329 123.99 107.25 123.99Z"
        fill="currentColor"
      />
      <path
        d="M107.25 113.05C104.39 113.05 101.54 111.94 99.3804 109.74L76.8604 86.7098C71.4004 81.1298 68.4004 73.7498 68.4004 65.9398V47.8398C68.4004 41.7598 73.3204 36.8398 79.4004 36.8398C85.4804 36.8398 90.4004 41.7598 90.4004 47.8398V65.9398C90.4004 67.9698 91.1804 69.8798 92.6004 71.3298L115.12 94.3698C119.37 98.7098 119.29 105.68 114.94 109.93C112.8 112.02 110.02 113.06 107.25 113.06V113.05Z"
        fill="currentColor"
      />
      <path
        d="M99.9703 230.65C112.087 230.65 121.91 220.827 121.91 208.71C121.91 196.593 112.087 186.77 99.9703 186.77C87.8531 186.77 78.0303 196.593 78.0303 208.71C78.0303 220.827 87.8531 230.65 99.9703 230.65Z"
        fill="currentColor"
      />
      <path
        d="M19.9494 197.454L19.8765 219.454L96.926 219.71L96.999 197.71L19.9494 197.454Z"
        fill="currentColor"
      />
      <path
        d="M58.1802 157.41C70.2974 157.41 80.1202 147.587 80.1202 135.47C80.1202 123.353 70.2974 113.53 58.1802 113.53C46.0631 113.53 36.2402 123.353 36.2402 135.47C36.2402 147.587 46.0631 157.41 58.1802 157.41Z"
        fill="currentColor"
      />
      <path
        d="M134.39 174.32H94.2901C86.4801 174.32 79.1001 171.31 73.5201 165.85L50.4801 143.33C46.1401 139.08 46.0601 132.12 50.3001 127.77C54.5501 123.43 61.5101 123.35 65.8601 127.59L88.9001 150.11C90.3501 151.53 92.2601 152.31 94.2901 152.31H134.39C140.47 152.31 145.39 157.23 145.39 163.31C145.39 169.39 140.47 174.31 134.39 174.31V174.32Z"
        fill="currentColor"
      />
      <path
        d="M240.7 217.05C252.817 217.05 262.64 207.227 262.64 195.11C262.64 182.993 252.817 173.17 240.7 173.17C228.583 173.17 218.76 182.993 218.76 195.11C218.76 207.227 228.583 217.05 240.7 217.05Z"
        fill="currentColor"
      />
      <path
        d="M316.91 233.96H276.81C269 233.96 261.63 230.95 256.04 225.5L233 202.98C228.66 198.73 228.58 191.77 232.82 187.42C237.07 183.08 244.03 183 248.38 187.24L271.42 209.76C272.87 211.18 274.78 211.96 276.81 211.96H316.91C322.99 211.96 327.91 216.88 327.91 222.96C327.91 229.04 322.99 233.96 316.91 233.96Z"
        fill="currentColor"
      />
      <path
        d="M77.1602 275.55C89.2773 275.55 99.1002 265.727 99.1002 253.61C99.1002 241.493 89.2773 231.67 77.1602 231.67C65.0431 231.67 55.2202 241.493 55.2202 253.61C55.2202 265.727 65.0431 275.55 77.1602 275.55Z"
        fill="currentColor"
      />
      <path
        d="M105.01 330.83C98.93 330.83 94.01 325.91 94.01 319.83V289.73C94.01 287.7 93.23 285.79 91.81 284.34L69.29 261.3C65.04 256.96 65.12 249.99 69.47 245.74C73.81 241.49 80.78 241.57 85.03 245.92L107.55 268.96C113.01 274.54 116.01 281.92 116.01 289.73V319.83C116.01 325.91 111.09 330.83 105.01 330.83Z"
        fill="currentColor"
      />
      <path
        d="M328.25 191.77H303.07C284.37 191.77 269.17 176.56 269.17 157.87V119.46C269.17 113.38 274.09 108.46 280.17 108.46C286.25 108.46 291.17 113.38 291.17 119.46V157.87C291.17 164.43 296.51 169.77 303.07 169.77H328.25C334.33 169.77 339.25 174.69 339.25 180.77C339.25 186.85 334.33 191.77 328.25 191.77Z"
        fill="currentColor"
      />
      <path
        d="M278.63 128.79C290.748 128.79 300.57 118.967 300.57 106.85C300.57 94.733 290.748 84.9102 278.63 84.9102C266.513 84.9102 256.69 94.733 256.69 106.85C256.69 118.967 266.513 128.79 278.63 128.79Z"
        fill="currentColor"
      />
      <path
        d="M205.79 166.41H192.91C186.83 166.41 181.91 161.49 181.91 155.41C181.91 149.33 186.83 144.41 192.91 144.41H205.79C212.35 144.41 217.7 139.07 217.7 132.51V94.1001C217.7 88.0201 222.62 83.1001 228.7 83.1001C234.78 83.1001 239.7 88.0201 239.7 94.1001V132.51C239.7 151.21 224.49 166.41 205.79 166.41Z"
        fill="currentColor"
      />
      <path
        d="M230.23 103.43C242.347 103.43 252.17 93.6069 252.17 81.4898C252.17 69.3727 242.347 59.5498 230.23 59.5498C218.113 59.5498 208.29 69.3727 208.29 81.4898C208.29 93.6069 218.113 103.43 230.23 103.43Z"
        fill="currentColor"
      />
      <path
        d="M248.25 288.51C260.367 288.51 270.19 278.687 270.19 266.57C270.19 254.453 260.367 244.63 248.25 244.63C236.133 244.63 226.31 254.453 226.31 266.57C226.31 278.687 236.133 288.51 248.25 288.51Z"
        fill="currentColor"
      />
      <path
        d="M248.209 255.568L187.16 255.824L187.252 277.824L248.301 277.568L248.209 255.568Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default UnderstandIcon;
